"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const computeComplexUnit_1 = __importDefault(require("./shared/computeComplexUnit"));
const colorComputers_1 = __importDefault(require("./shared/colorComputers"));
const shared_1 = require("../shared");
const computeFontSize_1 = __importDefault(require("./shared/computeFontSize"));
const formatBorderWith_1 = __importDefault(require("./shared/formatBorderWith"));
const controlStyleFormaterBuilder = (paletteShades, globalFontSize, onCompatibilityIssue) => {
    const getColorFromSpecification = (0, colorComputers_1.default)(paletteShades);
    const computeFontSize = (0, computeFontSize_1.default)(globalFontSize);
    const computeComplexUnit = (0, computeComplexUnit_1.default)(onCompatibilityIssue || (() => undefined));
    return (control, isWrapped) => {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r;
        const computedStyles = {};
        const originalStyle = control.style;
        if (!originalStyle) {
            return computedStyles;
        }
        (0, shared_1.copyPropsIfDefined)(originalStyle, computedStyles, ['width', 'height', 'marginBottom', 'marginLeft', 'marginRight', 'marginTop'], computeComplexUnit);
        (0, shared_1.copyPropsIfDefined)(originalStyle, computedStyles, [
            'color',
            'background',
            'backgroundColor',
            'placeHolderColor',
            'borderColor',
            'colorLines',
            'thumbColor', 'thumbBorderColor', 'selectionColor', 'blankColor',
            'statusBarColor',
            'trackColorActive',
            'trackColorDisiabled',
            'thumbColorActive',
            'thumbColorDisiabled',
        ], getColorFromSpecification);
        if (computedStyles.background
            && typeof computedStyles.background === 'string'
            && !computedStyles.backgroundColor) {
            // Some controls have no background color but have a background prop
            computedStyles.backgroundColor = computedStyles.background;
        }
        (0, shared_1.copyPropsIfDefined)(control, computedStyles, ['arrowsColor', 'badgeColor', 'badgeTextColor'], getColorFromSpecification);
        (0, shared_1.copyPropsIfDefined)(originalStyle, computedStyles, [
            'zIndex',
            'textAlign', 'fontWeight', 'fontStyle', 'textDecoration',
            'borderStyle',
            'shadowColor', 'shadowOffset', 'shadowOpacity', 'shadowRadius',
            'elevation',
            'borderTopWidth', 'borderRightWidth', 'borderBottomWidth', 'borderLeftWidth',
            'flexDirection', 'justifyContent', 'alignItems',
            'paddingBottom', 'paddingLeft', 'paddingRight', 'paddingTop',
            'borderTopRightRadius', 'borderTopLeftRadius', 'borderBottomRightRadius', 'borderBottomLeftRadius',
            'heightAuto',
        ]);
        (0, shared_1.copyPropsIfDefined)(originalStyle, computedStyles, ['fontSize'], computeFontSize);
        if ((originalStyle === null || originalStyle === void 0 ? void 0 : originalStyle.position) === 'absolute' && ['View', 'flatList', 'sectionList'].includes(control.tag)) {
            (0, shared_1.copyPropsIfDefined)(originalStyle, computedStyles, [
                'position',
                'top',
                'left',
                'right',
                'bottom',
            ]);
        }
        // Especial an dangerous control styles
        if (control.tag === 'sectionList') {
            const backgroundColor = (_b = (_a = control.listStyles) === null || _a === void 0 ? void 0 : _a.tab) === null || _b === void 0 ? void 0 : _b.background;
            if (backgroundColor) {
                computedStyles.sectionListTabBackground = getColorFromSpecification(backgroundColor);
            }
            const color = (_d = (_c = control.listStyles) === null || _c === void 0 ? void 0 : _c.tab) === null || _d === void 0 ? void 0 : _d.color;
            if (color) {
                computedStyles.sectionListColor = getColorFromSpecification(color);
            }
            const fontSizeSeparator = (_f = (_e = control.listStyles) === null || _e === void 0 ? void 0 : _e.tab) === null || _f === void 0 ? void 0 : _f.fontSizeSeparator;
            if (fontSizeSeparator) {
                computedStyles.sectionListFontSizeS = computeFontSize(fontSizeSeparator);
            }
            const fontSizeTopBar = (_h = (_g = control.listStyles) === null || _g === void 0 ? void 0 : _g.tab) === null || _h === void 0 ? void 0 : _h.fontSizeTopBar;
            if (fontSizeTopBar) {
                computedStyles.sectionListFontSizeTB = computeFontSize(fontSizeTopBar);
            }
            const heightSeparator = (_k = (_j = control.listStyles) === null || _j === void 0 ? void 0 : _j.tab) === null || _k === void 0 ? void 0 : _k.heightSeparator;
            const heightAutoSeparator = (_m = (_l = control.listStyles) === null || _l === void 0 ? void 0 : _l.tab) === null || _m === void 0 ? void 0 : _m.heightAutoSeparator;
            if (heightSeparator && !heightAutoSeparator) {
                computedStyles.sectionListHeightS = computeComplexUnit(heightSeparator);
            }
            else {
                computedStyles.sectionListHeightS = 'auto';
            }
            const heightTopBar = (_p = (_o = control.listStyles) === null || _o === void 0 ? void 0 : _o.tab) === null || _p === void 0 ? void 0 : _p.heightTopBar;
            const heightAutoTopBar = (_r = (_q = control.listStyles) === null || _q === void 0 ? void 0 : _q.tab) === null || _r === void 0 ? void 0 : _r.heightAutoTopBar;
            if (heightTopBar && !heightAutoTopBar) {
                computedStyles.sectionListHeightTB = computeComplexUnit(heightTopBar);
            }
            else {
                computedStyles.sectionListHeightTB = 'auto';
            }
        }
        (0, formatBorderWith_1.default)(computedStyles);
        if (isWrapped) {
            computedStyles.width = '100%';
            computedStyles.height = '100%';
            computedStyles.marginBottom = 0;
            computedStyles.marginLeft = 0;
            computedStyles.marginRight = 0;
            computedStyles.marginTop = 0;
            delete computedStyles.zIndex;
        }
        return computedStyles;
    };
};
exports.default = controlStyleFormaterBuilder;
